/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_For_WhomInputs */

const en_portal_nav_for_whom = /** @type {(inputs: Portal_Nav_For_WhomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who it's for`)
};

const pl_portal_nav_for_whom = /** @type {(inputs: Portal_Nav_For_WhomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla kogo`)
};

/**
* | output |
* | --- |
* | "Who it's for" |
*
* @param {Portal_Nav_For_WhomInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_for_whom = /** @type {((inputs?: Portal_Nav_For_WhomInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_For_WhomInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_for_whom(inputs)
	return en_portal_nav_for_whom(inputs)
});